module.exports = "<p class=\"avviso-ie\">\r\n  Per garantire una esperienza ottimale si consiglia di utilizzare Google Chrome, Mozilla Firefox o Microsoft Edge. Grazie!\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/avviso-ie/avviso-ie.component.html
// module id = ./src/app/avviso-ie/avviso-ie.component.html
// module chunks = main